<template>
  <div class="container-fluid">
    <div class="row flex-row">
      <div class="col-xl-12">
        <div class="widget has-shadow">
          <div class="widget-body">
            <button class="btn btn-primary mb-2" @click="goToNew">ساخت تبلیغ جدید</button>
            <div class="table-responsive">
              <table class="table mb-0">
                <thead>
                  <tr>
                    <th>برچسب (tag)</th>
                    <th>نوع</th>
                    <th>ترتیب</th>
                    <th>قابل کلیک</th>
                    <th>لینک</th>
                    <th>از تاریخ</th>
                    <th>تا تاریخ</th>
                    <th>وضعیت</th>
                    <th>تصویر</th>
                    <th>-</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="ad in advertisements" :key="ad._id">
                    <td>{{ ad.tag }}</td>
                    <td>{{ adTypeLabel(ad.adType) }}</td>
                    <td>{{ ad.order }}</td>
                    <td>{{ ad.isClickable ? 'بله' : 'خیر' }}</td>
                    <td>
                      <a v-if="ad.link" :href="ad.link" target="_blank" rel="noopener">لینک</a>
                      <span v-else>-</span>
                    </td>
                    <td>{{ formatDate(ad.fromDate) }}</td>
                    <td>{{ formatDate(ad.toDate) }}</td>
                    <td>{{ ad.isAvailable ? 'فعال' : 'غیرفعال' }}</td>
                    <td>
                      <a v-if="ad.imageAddress" :href="ad.imageAddress" target="_blank">مشاهده</a>
                      <span v-else>-</span>
                    </td>
                    <td>
                      <button class="btn btn-secondary" @click="goToEdit(ad._id)">ویرایش</button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import advertisementService from '../../../../services/advertisementService';

export default {
  name: 'Advertisements',
  data() {
    return {
      advertisements: [],
    };
  },
  created() {
    this.loadAdvertisements();
  },
  methods: {
    adTypeLabel(type) {
      return type === 'click' ? 'کلیکی' : 'نمایشی';
    },
    formatDate(value) {
      if (!value) return '-';
      return `${new Date(value).toLocaleDateString('fa-IR')} ${new Date(value).toLocaleTimeString('fa-IR')}`;
    },
    async loadAdvertisements() {
      try {
        this.advertisements = await advertisementService.getAdvertisements({});
      } catch (err) {
        console.log(err);
      }
    },
    goToNew() {
      this.$router.push('/dashboard/advertisements/new');
    },
    goToEdit(id) {
      this.$router.push(`/dashboard/advertisements/${id}`);
    },
  },
};
</script>
